// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2mWkK","inner":"Footer_inner__dYTCc","nextIcon":"Footer_nextIcon__3GO2X","innerLeft":"Footer_innerLeft__bmc7O"};